export default __webpack_public_path__ + "static/media/Foster_Care_Levels_of_Service.df44cda8.pdf";